import React, { createContext, useContext, useMemo, useState } from 'react'

const BottomBarContext = createContext()

export function BottomBarProvider({ children }) {
  const [bottomBarElements, setBottomBarElements] = useState({})

  const value = useMemo(() => ({
    bottomBarElements,
    setBottomBarElements,
  }), [bottomBarElements])

  return (
    <BottomBarContext.Provider value={value}>
      {children}
    </BottomBarContext.Provider>
  )
}

export function useBottomBar() {
  const context = useContext(BottomBarContext)
  if (!context) {
    throw new Error('useBottomBar must be used within a BottomBarProvider')
  }
  return context
}

// Component that pages can use to declare their BottomBar content
export function BottomBarContent({ children }) {
  const { setBottomBarElements } = useBottomBar()

  React.useEffect(() => {
    // Extract BottomBar elements from children
    const elements = {}

    React.Children.forEach(children, (child) => {
      if (React.isValidElement(child)) {
        const type = child.type?.displayName || child.type?.name
        if (type?.startsWith('BottomBar.')) {
          const key = type.replace('BottomBar.', '').toLowerCase()
          elements[key] = child
        }
      }
    })

    setBottomBarElements(elements)

    return () => setBottomBarElements({})
  }, [children, setBottomBarElements])

  // Don't render anything - this is just for declaring BottomBar content
  return null
}
